<div class="layout-center control-pointer" (click)="OnClick()">
    <div class="radio-button-container">
        <div class="radio-button-outer {{OuterClass}}" ></div>
        <div class="radio-button-inner {{InnerClass}}"></div>    
    </div>
    <div class="radio-button-label"
        [class.radio-button-label-disabled]="IsDisabled">{{Label}}</div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/radio/radio-button/radio-button.html